import ApplicationRecord from './ApplicationRecord';
import * as ReferenceSections from './ReferenceSection';
import ImageRecord from './ImageRecord';
export default class Reference extends ApplicationRecord({
  Title: '',
  Text: '',
  _embedded: {},
}) {
  /**
    * @return {ImageRecord} Image always shown
    */
  cover() {
    return this._getOne('CoverImg', ImageRecord);
  }

  /**
  * Get a list of References, dependant of the type
  * @return {List<? extends AbstractReference>}
  */
  sections() {
    return this._getMany(
      'ReferenceSections',
      referenceDoc =>
        new ReferenceSections[`ReferenceSection${referenceDoc.ReferenceType}`](
          referenceDoc
        )
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/Reference.js